var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prediction-details"},[_vm._v("\n  זה הסכום שהמערכת צופה ש"+_vm._s(_vm.actionText)+" ב\""+_vm._s(_vm.predictedTransaction.name)+"\" ב"+_vm._s(_vm.predictionTimePeriod)+" החודש\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }